export const NODE_ENV = "production";
export const NODE_DEBUG = void 0;
export const MODE = "production";
export const SSR = false;
